import { Flyout } from '../Flyout';
import './ContactBox.scss';
import contactPersonImg from '../../assets/images/contact-person.png';
import chatSvg from '../../assets/svgs/chat.svg';
import phoneSvg from '../../assets/svgs/phone.svg';
import locationSvg from '../../assets/svgs/location.svg';
import circleSvg from '../../assets/svgs/circle.svg';
import contactChevronRightSvg from '../../assets/svgs/contact-chevron-right.svg';
import { useState } from 'react';
import React from 'react';
import classNames from 'classnames';

declare global {
  interface Window {
    $zopim: any;
    adaEmbed: any;
  }
}

export type ContactBoxProps = {
  hasBorder?: boolean;
};

export const ContactBox = ({ hasBorder }: ContactBoxProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenZendChat = () => {
    if (typeof window.$zopim !== 'undefined') {
      window.$zopim.livechat.window.show();
    } else if ('adaEmbed' in window) {
      // Opens ada
      window.adaEmbed.toggle();
    }
    setIsOpen(false);
  };

  return (
    <>
      <button
        className={classNames('p-contact-box', {
          'p-contact-box__has-border': hasBorder,
        })}
        type="button"
        onClick={() => setIsOpen(true)}
      >
        <div className="p-contact-box__wrapper">
          <img
            className="p-contact-box__image"
            src={contactPersonImg}
            alt="Contact Person"
          />

          <div className="p-contact-box__content">
            <div className="p-contact-box__texts">
              <div className="p-contact-box__question">Have questions?</div>
              <div className="p-contact-box__answer">
                Talk to a Sleep Consultant for rejuvenating sleep and exclusive
                savings.
              </div>
            </div>
            <div className="p-contact-box__cta">
              <img src={contactChevronRightSvg} />
            </div>
          </div>
        </div>
      </button>

      <Flyout
        title="Have questions?"
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      >
        <div className="p-contact-flyout">
          <img
            className="p-contact-flyout__img"
            src={contactPersonImg}
            alt="Contact Profile"
          />

          <div className="p-contact-flyout__description">
            Talk to a Sleep Consultant for rejuvenating sleep and exclusive
            savings.
          </div>

          <div className="p-contact-flyout__options">
            <button
              className="p-contact-flyout__option"
              type="button"
              onClick={handleOpenZendChat}
            >
              <div className="p-contact-flyout__option__icon">
                <img src={chatSvg} />
              </div>
              <div className="p-contact-flyout__option__content">
                <h4 className="p-contact-flyout__option__content__title">
                  Chat with us
                </h4>
                <p className="p-contact-flyout__option__content__availability">
                  <img src={circleSvg} />
                  Available now
                </p>
              </div>
            </button>

            <a className="p-contact-flyout__option" href="tel:8888480665">
              <div className="p-contact-flyout__option__icon">
                <img src={phoneSvg} />
              </div>
              <div className="p-contact-flyout__option__content">
                <h4 className="p-contact-flyout__option__content__title">
                  Call 888-848-0665
                </h4>
                <p className="p-contact-flyout__option__content__availability">
                  <img src={circleSvg} />
                  Available now
                </p>
              </div>
            </a>

            <a
              className="p-contact-flyout__option"
              href="https://purple.com/stores"
            >
              <div className="p-contact-flyout__option__icon">
                <img src={locationSvg} />
              </div>
              <div className="p-contact-flyout__option__content">
                <h4 className="p-contact-flyout__option__content__title">
                  Find a store
                </h4>
                <p className="p-contact-flyout__option__content__subtitle">
                  1,000+ partners and over 50 showrooms
                </p>
              </div>
            </a>
          </div>

          <div className="p-contact-flyout__availability">
            <p className="p-contact-flyout__availability__title">
              Hours available
            </p>
            <p className="p-contact-flyout__availability__subtitle">
              Mon - Sun: 6:00am - 10:00pm MST
            </p>
          </div>
        </div>
      </Flyout>
    </>
  );
};
